import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import styles from './dialog.module.scss';
import { Icon } from '../icon';

export interface DialogProps {
  open: boolean;
  onClose: () => void;
  title: React.ReactNode;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  footerExtras?: React.ReactNode;
  className?: string;
  preventCloseOnOverlayClick?: boolean;
}

export const Dialog: React.FC<DialogProps> = ({
  open,
  onClose,
  title,
  children,
  footer,
  footerExtras,
  className,
  preventCloseOnOverlayClick = false
}) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div 
      className={styles.overlay} 
      onClick={(e) => {
        if (!preventCloseOnOverlayClick && e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div 
        className={classNames(styles.dialog, className)}
        role="dialog"
        aria-modal="true"
      >
        <div className={styles.dialogHeader}>
          {title}
          <button 
            type="button" 
            style={{ border: 'none', background: 'transparent', cursor: 'pointer', padding: 0, display: 'flex' }} 
            onClick={onClose}
            aria-label="Close dialog"
          >
            <Icon name="close" style={{ fontSize: '18px' }} />
          </button>
        </div>
        <div className={styles.dialogContainer}>
          {children}
        </div>
        {(footer || footerExtras) && (
          <div className={styles.dialogButtons}>
            <div>{footerExtras}</div>
            <div className={styles.buttons}>
              {footer}
            </div>
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};
